function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_button_link_1",
  transform: "translate(-20853 -1563.482)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2342",
  "data-name": "Rectangle 2342",
  transform: "translate(20853 1563.482)",
  fill: "rgba(255,255,255,0)",
  stroke: "rgba(143, 196, 64, 0.5)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 34,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 35,
  height: 33,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "link",
  transform: "translate(20864.057 1573.744)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1301",
  "data-name": "Path 1301",
  d: "M10,9.733a3.514,3.514,0,0,0,5.3.38L17.408,8a3.514,3.514,0,1,0-4.97-4.97l-1.209,1.2",
  transform: "translate(-4.438 -2.005)",
  fill: "none",
  stroke: "#285f74",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1302",
  "data-name": "Path 1302",
  d: "M10.433,10.4a3.514,3.514,0,0,0-5.3-.38L3.025,12.133a3.514,3.514,0,1,0,4.97,4.97l1.2-1.2",
  transform: "translate(-1.995 -4.132)",
  fill: "none",
  stroke: "#285f74",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

var SvgCopyLink = function SvgCopyLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_link.21a79839.svg";
export { ForwardRef as ReactComponent };